const s = [
  "admin",
  "systemadmin",
  "teamlead",
  "agent",
  "enduser"
], t = {
  admin: {
    privilegeLevel: 0,
    prettyName: "Administrator",
    prettyNamePlural: "Administrators",
    roles: ["admin", "systemadmin", "teamlead", "agent"]
  },
  systemadmin: {
    privilegeLevel: 1,
    prettyName: "System Administrator",
    prettyNamePlural: "System Administrators",
    roles: ["systemadmin", "teamlead", "agent"]
  },
  teamlead: {
    privilegeLevel: 2,
    prettyName: "Team Lead",
    prettyNamePlural: "Team Leads",
    roles: ["teamlead", "agent"]
  },
  agent: {
    privilegeLevel: 3,
    prettyName: "Agent",
    prettyNamePlural: "Agents",
    roles: ["agent"]
  },
  enduser: {
    privilegeLevel: 4,
    prettyName: "End User",
    prettyNamePlural: "End Users",
    roles: ["enduser"]
  }
};
function m(r = []) {
  return r.reduce((a, e) => e in t && t[e].privilegeLevel < t[a].privilegeLevel ? e : a, "enduser");
}
export {
  t as USER_ROLE_ATTRIBUTES,
  m as getHighestUserRole,
  s as userRoles
};
//# sourceMappingURL=index.js.map
